/**
 @ngdoc directive
 @name persistantTabDirective

 @description

 Designed to be used within _sideTabs.gsp and in conjunction with the PersistantTabDirective 

 Watches for changes to the persistantTab variable on Window and on change, updates the persistantTab
 scope variable

 @usage

 <div ng-controller="persistantTabController as tabController">
     <a href="targetController/targetMethod?tab={{tabController.persistantTab}}"></a>
 </div>
 
 --------------------------------------------------------------------------------
 
 <a href="pageTargetForTabOne" id="tabOne" persistant-tab="formModel.targetTab"></a>
 <a href="pageTargetForTabTwo" id="tabTwo" persistant-tab="formModel.targetTab"></a>
 <a href="pageTargetForTabThree" id="tabThree" persistant-tab="formModel.targetTab"></a>

 */

var persistantTabListener = function ($scope, $window) {
    $scope.persistantTab;

    $scope.$watch(function() {
        return $window.persistantTab
    }, function(newValue, oldValue) {
        $scope.persistantTab = newValue
    }, true)

    return $scope

};
persistantTabListener.$inject = ['$scope', '$window'];
angular.module('app').controller('persistantTabListener',persistantTabListener);